import styled from "styled-components";
import {
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  TableCell,
} from "../../constants/Styles";
import Link from "next/link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 500px;
`;

export const ButtonsArea = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  justify-content: center;

  > button {
    width: 50%;
  }
`;

export const Boards = styled.div`
  font-size: ${FONT_SIZE.size12};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const OrdersCell = styled(TableCell)`
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

export const VerticalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InvoiceSummaryVerticalList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const InvoiceSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
export const InvoiceCard = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  background-color: ${COLORS.darkGray};
  border-radius: 1rem;
  padding: 1rem;
`;

export const PropertyContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const OrderCardContainer = styled.div`
  width: 100%;
  border-radius: 2rem;
  display: flex;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
    ${COLORS.tableBackground};
  padding: 2rem;
  gap: 2rem;
`;

export const OrderInfo = styled.div`
  min-width: 0;
  flex: 5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

export const InfoRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const TitleInfoRow = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
`;

export const DetailsInfoRow = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
`;

export const ActionsRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const OrderIdLink = styled(Link)`
  text-decoration: none;
  color: ${COLORS.secondary};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight500};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    color: ${COLORS.secondary};
  }
`;

export const AddContactsForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ContactDescription = styled.div`
  margin: 1rem 0;
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size14};
`;

export const ContactItem = styled.div`
  height: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${COLORS.secondaryLight};
`;

export const ContactsContainer = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid ${COLORS.inputGray};
`;

export const ContactsListContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ContactsTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
`;

export const OrderState = styled.div`
  border-radius: 100px;
  background: ${COLORS.badgeGray};
  padding: 0.25rem.75rem 0.25rem 0.5rem;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight500};
  gap: 2px;
  height: 24px;
`;

export const InvoicesContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size13};
  font-weight: ${FONT_WEIGHT.weight500};
`;
